function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3{fill:none;}.cls-1,.cls-2{stroke:#000;}.cls-1,.cls-2,.cls-3{stroke-miterlimit:10;}.cls-2{fill:#ac893a;}.cls-3{stroke:#ac893a;stroke-width:2px;}"));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "kurs_regularny");

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M75.4,235.5A11.61,11.61,0,0,1,63.8,247a11.32,11.32,0,0,1-8.3-3.4,10.94,10.94,0,0,1-3.4-8.2,11.32,11.32,0,0,1,3.4-8.3,10.94,10.94,0,0,1,8.2-3.4,11.61,11.61,0,0,1,11.7,11.8Z",
  transform: "translate(-21.6 -16.7)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M75.4,288.8a11.61,11.61,0,0,1-11.6,11.5,11.32,11.32,0,0,1-8.3-3.4,10.94,10.94,0,0,1-3.4-8.2,11.32,11.32,0,0,1,3.4-8.3,10.94,10.94,0,0,1,8.2-3.4,11.32,11.32,0,0,1,8.3,3.4A11.55,11.55,0,0,1,75.4,288.8Z",
  transform: "translate(-21.6 -16.7)"
});

var _ref6 = /*#__PURE__*/React.createElement("line", {
  className: "cls-1",
  y1: 105,
  x2: 172.3,
  y2: 105
});

var _ref7 = /*#__PURE__*/React.createElement("line", {
  className: "cls-1",
  y1: 95.7,
  x2: 257.7,
  y2: 95.7
});

var _ref8 = /*#__PURE__*/React.createElement("line", {
  className: "cls-1",
  y1: 85.9,
  x2: 63,
  y2: 85.9
});

var _ref9 = /*#__PURE__*/React.createElement("line", {
  className: "cls-1",
  y1: 76.6,
  x2: 63,
  y2: 76.6
});

var _ref10 = /*#__PURE__*/React.createElement("line", {
  className: "cls-1",
  y1: 66.8,
  x2: 63,
  y2: 66.8
});

var _ref11 = /*#__PURE__*/React.createElement("line", {
  className: "cls-1",
  y1: 57.5,
  x2: 63,
  y2: 57.5
});

var _ref12 = /*#__PURE__*/React.createElement("line", {
  className: "cls-1",
  y1: 47.7,
  x2: 63,
  y2: 47.7
});

var _ref13 = /*#__PURE__*/React.createElement("line", {
  className: "cls-1",
  y1: 38.5,
  x2: 63,
  y2: 38.5
});

var _ref14 = /*#__PURE__*/React.createElement("line", {
  className: "cls-1",
  y1: 29.2,
  x2: 63,
  y2: 29.2
});

var _ref15 = /*#__PURE__*/React.createElement("line", {
  className: "cls-1",
  y1: 19.9,
  x2: 63,
  y2: 19.9
});

var _ref16 = /*#__PURE__*/React.createElement("line", {
  className: "cls-1",
  y1: 10.1,
  x2: 63,
  y2: 10.1
});

var _ref17 = /*#__PURE__*/React.createElement("line", {
  className: "cls-1",
  y1: 143.2,
  x2: 37.6,
  y2: 143.2
});

var _ref18 = /*#__PURE__*/React.createElement("line", {
  className: "cls-1",
  y1: 133.9,
  x2: 37.6,
  y2: 133.9
});

var _ref19 = /*#__PURE__*/React.createElement("line", {
  className: "cls-1",
  y1: 124.1,
  x2: 37.6,
  y2: 124.1
});

var _ref20 = /*#__PURE__*/React.createElement("line", {
  className: "cls-1",
  y1: 114.8,
  x2: 37.6,
  y2: 114.8
});

var _ref21 = /*#__PURE__*/React.createElement("polyline", {
  className: "cls-1",
  points: "63 0.5 63 95.3 86.2 95.3 86.2 0.5"
});

var _ref22 = /*#__PURE__*/React.createElement("polyline", {
  className: "cls-1",
  points: "172.3 96.1 172.3 196.4 195.6 196.4 195.6 96.1"
});

var _ref23 = /*#__PURE__*/React.createElement("line", {
  className: "cls-1",
  x1: 86.2,
  y1: 85.7,
  x2: 256.9,
  y2: 85.7
});

var _ref24 = /*#__PURE__*/React.createElement("line", {
  className: "cls-1",
  x1: 86.2,
  y1: 76.4,
  x2: 256.9,
  y2: 76.4
});

var _ref25 = /*#__PURE__*/React.createElement("line", {
  className: "cls-1",
  x1: 86.2,
  y1: 66.6,
  x2: 256.9,
  y2: 66.6
});

var _ref26 = /*#__PURE__*/React.createElement("line", {
  className: "cls-1",
  x1: 86.2,
  y1: 57.3,
  x2: 256.9,
  y2: 57.3
});

var _ref27 = /*#__PURE__*/React.createElement("line", {
  className: "cls-1",
  x1: 86.2,
  y1: 47.5,
  x2: 256.9,
  y2: 47.5
});

var _ref28 = /*#__PURE__*/React.createElement("line", {
  className: "cls-1",
  x1: 86.2,
  y1: 38.2,
  x2: 256.9,
  y2: 38.2
});

var _ref29 = /*#__PURE__*/React.createElement("line", {
  className: "cls-1",
  x1: 86.2,
  y1: 28.9,
  x2: 256.9,
  y2: 28.9
});

var _ref30 = /*#__PURE__*/React.createElement("line", {
  className: "cls-1",
  x1: 86.2,
  y1: 19.6,
  x2: 256.9,
  y2: 19.6
});

var _ref31 = /*#__PURE__*/React.createElement("line", {
  className: "cls-1",
  x1: 86.2,
  y1: 9.8,
  x2: 256.9,
  y2: 9.8
});

var _ref32 = /*#__PURE__*/React.createElement("line", {
  className: "cls-1",
  x1: 195.6,
  y1: 105,
  x2: 257.7,
  y2: 105
});

var _ref33 = /*#__PURE__*/React.createElement("line", {
  className: "cls-1",
  x1: 195.6,
  y1: 143.2,
  x2: 257.7,
  y2: 143.2
});

var _ref34 = /*#__PURE__*/React.createElement("line", {
  className: "cls-1",
  x1: 195.6,
  y1: 133.9,
  x2: 257.7,
  y2: 133.9
});

var _ref35 = /*#__PURE__*/React.createElement("line", {
  className: "cls-1",
  x1: 195.6,
  y1: 124.1,
  x2: 257.7,
  y2: 124.1
});

var _ref36 = /*#__PURE__*/React.createElement("line", {
  className: "cls-1",
  x1: 195.6,
  y1: 114.8,
  x2: 257.7,
  y2: 114.8
});

var _ref37 = /*#__PURE__*/React.createElement("line", {
  className: "cls-1",
  x1: 110,
  y1: 143.2,
  x2: 172.3,
  y2: 143.2
});

var _ref38 = /*#__PURE__*/React.createElement("line", {
  className: "cls-1",
  x1: 110,
  y1: 133.9,
  x2: 172.3,
  y2: 133.9
});

var _ref39 = /*#__PURE__*/React.createElement("line", {
  className: "cls-1",
  x1: 110,
  y1: 124.1,
  x2: 172.3,
  y2: 124.1
});

var _ref40 = /*#__PURE__*/React.createElement("line", {
  className: "cls-1",
  x1: 110,
  y1: 114.8,
  x2: 172.3,
  y2: 114.8
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M96.2,102.1a52.2,52.2,0,1,0,52.2,52.2A52.17,52.17,0,0,0,96.2,102.1Zm0,79.6a27.3,27.3,0,1,1,27.3-27.3A27.27,27.27,0,0,1,96.2,181.7Z",
  transform: "translate(-21.6 -16.7)"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M205.6,191.9a52.2,52.2,0,1,0,52.2,52.2A52.17,52.17,0,0,0,205.6,191.9Zm0,79.5a27.3,27.3,0,1,1,27.3-27.3A27.27,27.27,0,0,1,205.6,271.4Z",
  transform: "translate(-21.6 -16.7)"
});

var _ref43 = /*#__PURE__*/React.createElement("line", {
  className: "cls-1",
  y1: 0.5,
  x2: 256.9,
  y2: 0.5
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  d: "M75.4,182.2a11.61,11.61,0,0,1-11.6,11.5,11.32,11.32,0,0,1-8.3-3.4,10.94,10.94,0,0,1-3.4-8.2,11.32,11.32,0,0,1,3.4-8.3,10.94,10.94,0,0,1,8.2-3.4,11.61,11.61,0,0,1,11.7,11.8Z",
  transform: "translate(-21.6 -16.7)"
});

var _ref45 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-3",
  cx: 74.6,
  cy: 137.7,
  r: 27.3
});

var _ref46 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-3",
  cx: 184,
  cy: 227.4,
  r: 27.3
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  d: "M257.2,206.7a11.61,11.61,0,0,1-11.6,11.5,11.32,11.32,0,0,1-8.3-3.4,10.94,10.94,0,0,1-3.4-8.2,11.32,11.32,0,0,1,3.4-8.3,10.94,10.94,0,0,1,8.2-3.4,11.61,11.61,0,0,1,11.7,11.8Z",
  transform: "translate(-21.6 -16.7)"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  d: "M257.2,260.1a11.61,11.61,0,0,1-11.6,11.5,11.32,11.32,0,0,1-8.3-3.4,10.94,10.94,0,0,1-3.4-8.2,11.32,11.32,0,0,1,3.4-8.3,10.94,10.94,0,0,1,8.2-3.4,11.61,11.61,0,0,1,11.7,11.8Z",
  transform: "translate(-21.6 -16.7)"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  d: "M257.2,153.4a11.61,11.61,0,0,1-11.6,11.5,11.32,11.32,0,0,1-8.3-3.4,10.94,10.94,0,0,1-3.4-8.2,11.32,11.32,0,0,1,3.4-8.3,10.94,10.94,0,0,1,8.2-3.4,11.61,11.61,0,0,1,11.7,11.8Z",
  transform: "translate(-21.6 -16.7)"
});

var SvgKursRegularny = function SvgKursRegularny(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    "data-name": "Warstwa 1",
    viewBox: "0 0 257.7 283.6",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgKursRegularny, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/kurs_regularny.57e257ab.svg";
export { ForwardRef as ReactComponent };